import { createWebHistory, createRouter } from 'vue-router';


const routes = [
    {
        path: '/res/mvc.php/web_menus_tool/app',
        name: 'home',
        component: () => import('./views/Home.vue')
    },
    {
        path: '/res/mvc.php/web_menus_tool/addMenu',
        name: 'addMenu',
        component: () => import('./views/EditMenu.vue')
    },
    {
        path: '/res/mvc.php/web_menus_tool/editMenu/:menuId',
        name: 'editMenu',
        component: () => import('./views/EditMenu.vue')
    },
    {
        path: '/res/mvc.php/web_menus_tool/listMenuItems/:menuId',
        name: 'listMenuItems',
        component: () => import('./views/ListMenuItems.vue')
    },
    {
        path: '/res/mvc.php/web_menus_tool/addMenuItem/:menuId',
        name: 'addMenuItem',
        component: () => import('./views/EditMenuItem.vue')
    },
    {
        path: '/res/mvc.php/web_menus_tool/editMenuItem/:menuId/:itemId',
        name: 'editMenuItem',
        component: () => import('./views/EditMenuItem.vue')
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
